import * as React from "react";
import { css } from "@emotion/react";
import { starIconStyle } from "main/javascripts/styles/fontStyle";
import { accentColor } from "main/javascripts/styles/base/colorStyle";
import { fontSize } from "main/javascripts/styles/base/typographyStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  rating: number;
}

const getStarStyle: any = (rating: number): any => {
  const starVal: number = Math.round(rating * 2) / 2;
  const starString = `star${starVal.toString().replace(".", "_")}`;
  return starIconStyle[starString];
};

export const StarRating: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> | null => {
  const { rating, ...rest } = props;
  if (rating === 0) {
    return null;
  }
  return (
    <div css={blockStyle} {...rest}>
      <div css={iconBlockStyle}>
        <div css={[starRatingStyle, starIconStyle.starEmpty]} />
        <div css={[starRatingStyle, starPositiveStyle, getStarStyle(rating)]} />
      </div>
    </div>
  );
};

const starRatingStyle = css`
  color: ${accentColor.starColor};
  overflow: hidden;
  margin: 0;
  line-height: 1;
`;
const starPositiveStyle = css`
  position: absolute;
  top: 0;
  left: 0;
`;
const iconBlockStyle = css`
  position: relative;
  display: inline-block;
  vertical-align: middle;
`;
const blockStyle = css`
  position: relative;
  font-size: ${fontSize.body};
  line-height: 0.1;
`;
